import { ReactNode, useCallback, useMemo, useState } from 'react'

import { ColorSchemeContext } from '@/modules/shared/providers/ColorSchemeContext'
import { applyDocumentColorScheme } from '@/modules/shared/utils/applyDocumentColorScheme'

export function ColorSchemeProvider({ children }: { children: ReactNode }) {
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'))

  const toggleColorScheme = useCallback(() => {
    setIsDark((prev) => {
      const next = !prev
      applyDocumentColorScheme(next)
      return next
    })
  }, [])

  const value = useMemo(() => ({ isDark, toggleColorScheme }), [isDark, toggleColorScheme])
  return <ColorSchemeContext.Provider value={value}>{children}</ColorSchemeContext.Provider>
}
